import { StreamData } from 'types/streamData'
import { FieldResolver } from '../fieldResolver'
import { Metadata } from '../../adaptor/metadata'

const originalAuthorResolver: FieldResolver = (metadata: Metadata) =>
  ({ originalAuthor: metadata.getOriginalAuthor() } as StreamData)

export default originalAuthorResolver
